import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToastSeeker } from "@app"
import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import { isLoadingUserSettingCategoryData, userSettingCategoryData, userSettingCategoryFormData, isEditUserSettingsCategoryDrawer } from "../@signals"


export default function useUserSettingsCategory(rowData={}) {
	const { showToast } = useToastSeeker()
	const isLoading = useSignal(false)

	const getCategoryData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.CRUD}/user/category_color`)
			.then(data => userSettingCategoryData.value = data)
			.catch(() => {
				showToast.error()
				userSettingCategoryData.value = []
			}).finally(() => isLoadingUserSettingCategoryData.value = false)
	}, [])

	const handleSetCategoryFormData = useCallback(() => userSettingCategoryFormData.value = {
		id: rowData.id || null,
		color: rowData.color,
		id_category: rowData.id_category || null,
		service_type: SERVICES_TYPE.CATEGORY_COLOR
	}, [JSON.stringify(rowData)])

	const handleChangeCategoryFormData = useCallback((newValue, prop) => userSettingCategoryFormData.value = {
		...userSettingCategoryFormData.value,
		[prop]: newValue
	}, [])

	const handleSubmitCategoryFormData = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.CRUD}/${!isEditUserSettingsCategoryDrawer.value ? 'add' : 'update'}`, userSettingCategoryFormData.value).then(res => {
			if (isEditUserSettingsCategoryDrawer.value) {
				userSettingCategoryData.value = [
					...userSettingCategoryData.value.map(item => item.id === userSettingCategoryFormData.value.id ? res : item)
				]
			} else {
				userSettingCategoryData.value = [
					...userSettingCategoryData.value,
					res
				]
			}
			userSettingCategoryFormData.value = {}
		}).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	const handleDeleteCategory = useCallback(() => showToast.confirm(`Are you sure you want to delete this row? This action cannot be undone.`, {
		onSubmit: () => {
			isLoading.value = true
			deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.CATEGORY_COLOR}?id=${rowData.id}`).then(() => {
				userSettingCategoryData.value = [
					...userSettingCategoryData.value.filter(item => item.id !== rowData.id)
				]
			}).catch(() => showToast.error())
				.finally(() => isLoading.value = false)
		}
	}), [JSON.stringify(rowData)])

	return {
		isClicked: rowData.id === userSettingCategoryFormData.value.id,
		isLoading: isLoading.value,
		getCategoryData,
		handleSetCategoryFormData,
		handleChangeCategoryFormData,
		handleSubmitCategoryFormData,
		handleDeleteCategory
	}
}